import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../util/network-call/network-call";

export const AdminCourseListLoader = async (args: LoaderFunctionArgs) => {

    const getCoursesResponse = await networkCall(`/users/${ args.params.id }/courses`);

    return { getCoursesResponse, id: args.params.id };

};